import { render, staticRenderFns } from "./IconCreateShipment.vue?vue&type=template&id=15eea679"
import script from "./IconCreateShipment.vue?vue&type=script&lang=ts"
export * from "./IconCreateShipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports